import React from "react";
import useStyles from "../styles";

function ErrorText(props) {
  const classes = useStyles();
  return <div className={classes.errText}>{props.children}</div>;
}

export default ErrorText;
